module.exports = __webpack_public_path__ + "static/media/Icon_Painting.851bf89e.png";